module.exports = __webpack_public_path__ + "static/media/nwhacks2020.3a9f366a.jpg";